import React from 'react';

import MemberTypeCard from 'shared/components/member-type-card/member-type-card';
import type { NamedFC } from 'shared/types/named-fc.types';

import Layout from 'ui/components/layout/layout';

import type { ChooseMemberType as Props } from './choose-member-type.props';

const ChooseMemberType: NamedFC<Props> = ({ layout, memberTypes }) => (
  <Layout {...layout}>
    <div className="choose-member-type">
      <div className="choose-member-type__member-types">
        {memberTypes
          ? memberTypes.map(memberType => (
              <MemberTypeCard key={memberType.id} {...memberType} />
            ))
          : null}
      </div>
    </div>
  </Layout>
);

ChooseMemberType.displayName = 'ChooseMemberType';

export default ChooseMemberType;
